export default __webpack_public_path__ + "static/media/tdlanding.f7cda6b4.png";